module.exports = __webpack_public_path__ + "static/media/内外饰件及座椅.0a76069d.png";


//////////////////
// WEBPACK FOOTER
// ./src/project/dongfeng/faultDiagnosis/demo/image/内外饰件及座椅.png
// module id = 1717
// module chunks = 174